<template>
  <div class="dashboard">
    <a-row :gutter="[18, 18]">
      <a-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="8">
        <TotalEmployee class="dashboard-item" :totalemployee="totalemployee" />
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="8">
        <EmployeeByCompany />
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="8">
        <EmployeeByGrade />
      </a-col>
    </a-row>
    <div class="dashboard-mid">
      <EmployeeByManyGrade />
    </div>

    <a-row :gutter="[8, 8]">
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
        <div class="dashboard-employee__seniority">
          <EmployeeSeniority />
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
        <div class="employee-month__seniority">
          <EmployeeMonthSeniority />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <DashboardTable />
    </a-row>
  </div>
</template>

<script>
import TotalEmployee from "./TotalEmployee.vue";
import EmployeeByCompany from "./EmployeeByCompany.vue";
import EmployeeByGrade from "./EmployeeByGrade.vue";
import EmployeeByManyGrade from "./EmployeeByManyGrade.vue";
import EmployeeSeniority from "./EmployeeSeniority.vue";
import EmployeeMonthSeniority from "./EmployeeMonthSeniority.vue";
import DashboardTable from "./DashboardTable.vue";

export default {
  name: "Dashboard",
  components: {
    TotalEmployee,
    EmployeeByCompany,
    EmployeeByGrade,
    EmployeeByManyGrade,
    EmployeeSeniority,
    EmployeeMonthSeniority,
    DashboardTable,
  },

  data() {
    return {
      totalemployee: "",
    };
  },
  async created() {},

  methods: {
    getData(amount) {
      this.getTotalEmployeee(amount);
    },
    async getTotalEmployeee() {
      await this.$store.dispatch("dashboard/getEmployeees");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 0 20px 20px;

  .dashboard-employee__seniority {
    background: #ffffff;
    border: 1px solid #efefef;
    border-radius: 10px;
    margin-top: 15px;
  }

  .employee-month__seniority {
    background: #ffffff;
    border: 1px solid #efefef;
    border-radius: 10px;
    margin-top: 15px;
  }
}
</style>


